
import { Control, Controller, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { DatePicker } from '@/components/ui/date-picker';
import type { Application } from '@/types/database.types';
import type { PayScheduleType } from '@/types/database/common-types';

export interface PrimaryScheduleProps {
  control: Control<Partial<Application>>;
  register: UseFormRegister<Partial<Application>>;
  watch: UseFormWatch<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
}

export const PrimarySchedule = ({ control, watch, setValue }: PrimaryScheduleProps) => {
  const scheduleType = watch('pay_schedule_type');
  
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <Label>Pay Schedule Type</Label>
        <Controller
          name="pay_schedule_type"
          control={control}
          render={({ field }) => (
            <RadioGroup
              value={field.value as string}
              onValueChange={(value) => field.onChange(value as PayScheduleType)}
              className="flex flex-col space-y-2"
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="Weekly" id="weekly" />
                <Label htmlFor="weekly" className="cursor-pointer">Weekly</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="Bi-Weekly" id="bi-weekly" />
                <Label htmlFor="bi-weekly" className="cursor-pointer">Bi-Weekly</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="Semi-Monthly" id="semi-monthly" />
                <Label htmlFor="semi-monthly" className="cursor-pointer">Semi-Monthly</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="Monthly" id="monthly" />
                <Label htmlFor="monthly" className="cursor-pointer">Monthly</Label>
              </div>
            </RadioGroup>
          )}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="pay_period_start">Period Start</Label>
          <Controller 
            name="pay_period_start"
            control={control}
            render={({ field }) => (
              <DatePicker
                id="pay_period_start"
                date={field.value ? new Date(field.value) : undefined}
                onSelect={(date) => field.onChange(date ? date.toISOString() : undefined)}
                placeholder="Select date"
              />
            )}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="pay_period_end">Period End</Label>
          <Controller 
            name="pay_period_end"
            control={control}
            render={({ field }) => (
              <DatePicker
                id="pay_period_end"
                date={field.value ? new Date(field.value) : undefined}
                onSelect={(date) => field.onChange(date ? date.toISOString() : undefined)}
                placeholder="Select date"
              />
            )}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="next_check_date">Pay Date</Label>
          <Controller 
            name="next_check_date"
            control={control}
            render={({ field }) => (
              <DatePicker
                id="next_check_date"
                date={field.value ? new Date(field.value) : undefined}
                onSelect={(date) => field.onChange(date ? date.toISOString() : undefined)}
                placeholder="Select date"
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};
